import React from 'react';
import LoadingContainer from '../../components/common/LoadingContainer';
import CustomLoader from '../../components/common/CustomLoader';
import InlineLoader from '../../components/common/InlineLoader';

interface LoadingSpinnerProps {
  size?: number;
  message?: string;
  fullScreen?: boolean;
  minHeight?: string | number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 40, 
  message = 'LOADING',
  fullScreen = false,
  minHeight = '400px'
}) => {
  // Use LoadingContainer for full screen or section loading
  if (fullScreen || minHeight) {
    return (
      <LoadingContainer 
        loading={true}
        fullPage={fullScreen}
        minHeight={minHeight}
        message={message}
        size={size}
      />
    );
  }

  // For other cases, use CustomLoader directly
  return <CustomLoader size={size} message={message} />;
};

// Inline loading spinner for use within buttons or small spaces
export const InlineLoadingSpinner: React.FC<{ size?: number }> = ({ size = 16 }) => {
  return <InlineLoader size={size} />;
};